<template>
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <dr-text-area-spilka-ui-kit 
      v-if="currentUIKit === 'spilkaUIKit'" 
      :value="getDataSourceField(model.Text)" 
      :label="evaluateExpression(model.Caption)"
      :class="evaluateClasses(classes)"
      @input="setDataSourceField(model.Text, $event)"
    />
    <v-textarea
      v-else
      :value="getDataSourceField(model.Text)"
      :class="evaluateClasses(classes)"
      @input="setDataSourceField(model.Text, $event)"
      :label="evaluateExpression(model.Caption)"
      :regular="isRegular"
      :solo="isSolo"
      :outlined="isOutlined"
      :filled="isFilled"
    ></v-textarea>
  </dr-wrapper>
  <dr-text-area-spilka-ui-kit 
    v-else-if="isVisible && currentUIKit === 'spilkaUIKit'" 
    :value="getDataSourceField(model.Text)" 
    :label="evaluateExpression(model.Caption)"
    :class="evaluateClasses(classes)"
    @input="setDataSourceField(model.Text, $event)" 
    @change="invokeActionOnClick(model.GenerationOnChange, { value: $event })" 
  />
  <v-textarea
    v-else-if="isVisible"
    :value="getDataSourceField(model.Text)"
    :class="evaluateClasses(classes)"
    :rules="_isRequiredField"
    @input="setDataSourceField(model.Text, $event)"
    @change="invokeActionOnClick(model.GenerationOnChange, { value: $event })"
    :label="evaluateExpression(model.Caption)"
    :regular="isRegular"
    :solo="isSolo"
    :outlined="isOutlined"
    :filled="isFilled"
  ></v-textarea>
</template>

<script>
import inputMixin from '../../mixins/input-mixin'
import baseMixin from '../../mixins/base-mixin'
import actionMixin from '../../mixins/actions-mixin'
import drTextAreaSpilkaUiKit from './dr-text-area-spilka-ui-kit.vue'
import { widgetWrappersCollection } from '../../tools/widgetWrapper/widgetWrappersCollection'
import { WidgetWrapperEntity } from '../../tools/widgetWrapper/widgetsWrapperEntity.js'

export default {
  components: { drTextAreaSpilkaUiKit },
  mixins: [inputMixin, baseMixin, actionMixin],
  created() {
    widgetWrappersCollection[this.model.$ID] = new WidgetWrapperEntity({
      model: this.model,
      getValue: () => this.getDataSourceField(this.model.Text),
      setValue: (val) => this.setDataSourceField(this.model.Text, val)
    })
  },

  computed: {
    _isRequiredField() {
      if (!this.model.Required) {
        return []
      }
      return [(val) => (val || '').length > 0 || `${this.model.Caption} - ${this.$t('drTestField.required')}`]
    }
  }
}
</script>

<style>
</style>
